import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';

import { config } from '~/config';

type ReportsPagePropsResponse = {
  referenceData: {
    intakeTerms: Record<string, { name: string; startsOn: string }>;
    campuses: Record<string, { name: string }>;
    agencies: Record<string, { name: string }>;
    nationalities: Record<
      string,
      {
        alpha3Code: string;
        countryLabel: string;
        nationalityLabel: string;
      }
    >;
  };
};

export type ReferenceData = ReportsPagePropsResponse['referenceData'];
export type InitialQueryParameter = {};
export type ReportsPageInitialProps = ReportsPagePropsResponse;

export function useReportsPageProps() {
  const request = useRequest();
  const { isLoading, data, isError, error } = useQuery({
    queryKey: ['useReportsPageProps'],
    queryFn: async () => {
      const response = await request<ReportsPagePropsResponse>(`${config.apiHost}/private/v1/reports/page_props`, {
        isExpectedResponse,
      });
      const result: ReportsPageInitialProps = {
        referenceData: {
          intakeTerms: response.referenceData.intakeTerms,
          campuses: response.referenceData.campuses,
          agencies: response.referenceData.agencies,
          nationalities: response.referenceData.nationalities,
        },
      };
      return result;
    },
  });
  return {
    isInitialPropsError: isError,
    initialPropsError: error,
    isLoadingInitialProps: isLoading,
    initialProps: data,
  };
}

function isExpectedResponse(res: unknown): res is ReportsPagePropsResponse {
  return Boolean(res && typeof res === 'object');
}
